@if (config()) {
  <div class="parameter-visibility-flags-config">
    <mat-form-field
      class="parameter-visibility-flags-config__field without-subscript small-form-field"
      appearance="outline"
    >
      @if (!hideLabel()) {
        <mat-label>{{ parameterTitle }}</mat-label>
      }
      <mat-select
        [multiple]="true"
        [value]="selectedSubsystemIdentifiers()"
        [disabled]="disabled() || readonly()"
        (selectionChange)="onSelectionChange($event)"
      >
        @for (subsystem of sortedSubsystems(); track subsystem.identifier) {
          <mat-option [value]="subsystem.identifier">
            {{ subsystem.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (config().parameter.description && showInfo()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            class="parameter-visibility-flags-config__icon"
            color="accent"
            [matTooltip]="config().parameter.description"
            >info_outline
          </mat-icon>
        </button>
      </div>
    }
    @if (!disabled()) {
      @if (value() && !readonly() && hasDelete()) {
        <div class="small-icon-button-wrapper">
          <button mat-icon-button>
            <mat-icon
              (click)="onClickRemove()"
              class="parameter-visibility-flags-config__close"
              color="warn"
              matTooltip="Discard changes"
              >close
            </mat-icon>
          </button>
        </div>
      }
      @if (value() && !readonly() && hasUndo()) {
        <div class="small-icon-button-wrapper">
          <button mat-icon-button>
            <mat-icon
              (click)="onClickUndo()"
              class="parameter-visibility-flags-config__close"
              color="warn"
              matTooltip="Discard changes"
              >close
            </mat-icon>
          </button>
        </div>
      }
      @if (hasClose()) {
        <div class="small-icon-button-wrapper">
          <button mat-icon-button>
            <mat-icon (click)="onClickConfigClose()" matTooltip="Close">close</mat-icon>
          </button>
        </div>
      }
      @if (showReset()) {
        <div class="small-icon-button-wrapper">
          <button
            mat-icon-button
            (click)="onResetToFactory()"
            [matTooltip]="resetToFactoryTooltip()"
          >
            <mat-icon color="warn">replay</mat-icon>
          </button>
        </div>
      }
    }
  </div>
}
